import { createContext } from 'react';

import { FeatureAppEnvironment } from '@feature-hub/core';

import { FeatureAppConfig, FeatureAppDependencies } from '../FeatureAppDefinition';
import { useSafeContext } from './use-safe-context';

export type CurrentFeatureAppEnvironment = FeatureAppEnvironment<
  FeatureAppDependencies,
  FeatureAppConfig
>;

export const FeatureAppEnvironmentContext = createContext<
  CurrentFeatureAppEnvironment | undefined
>(undefined);

export function useFeatureAppEnvironment(): CurrentFeatureAppEnvironment {
  return useSafeContext(FeatureAppEnvironmentContext, 'featureAppEnvironment');
}
